import styled from "@emotion/styled";

export const IndexWrap = styled.section`
  @media screen and (max-width: 992px) {
  }
`;
